import React, { useMemo, useRef } from 'react';
import { TextBox } from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';
import ScrollView from 'devextreme-react/scroll-view';
import { IModalConfig } from '../../../types/modal';
import Modal from '../../common/modal/Modal';
import { MarsApiService as api } from '../../../api/mars-api-service';
import { MarsApiConfig as apiConfig } from '../../../api/mars-api-config';
import Validator from 'devextreme-react/validator';
import { useLoaderContext } from '../../../contexts/LoaderContext';
import { useTranslation } from 'react-i18next';
import ValidationGroup from 'devextreme-react/validation-group';
import toast from '../../../utils/toast';
import { IAddNewBerth } from '../../../types/port-configurations';

export default function AddNewBerth(props: {
  isAddNewBerth: any;
  setIsAddNewBerth: any;
  terminalCode?: any;
  setIsFromAddBerth?: any;
}) {
  const { t } = useTranslation();
  const validationGroupBerthName: any = useRef();
  const validationGroupBerthCode: any = useRef();
  const [berthName, setBerthName] = React.useState('');
  const [berthCode, setBerthcode] = React.useState('');
  const { isAddNewBerth, setIsAddNewBerth, terminalCode, setIsFromAddBerth } =
    props;

  const { setIsLoading } = useLoaderContext();

  const popupAttributesChangePWD = useMemo(() => {
    return {
      id: 'elementId',
      class: 'm-l-modal-main__wrap m-l-modal-change__pwd',
    };
  }, []);

  const handleCancelClick = () => {
    setIsAddNewBerth(false);
    clearFields();
  };

  const clearFields = () => {
    setBerthName('');
    setBerthcode('');
  };

  const modalConfigChangePWD: IModalConfig = {
    width: 400,
    height: 434,
    visible: isAddNewBerth,
    showTitle: false,
    closeOnOutsideClick: false,
  };

  const onAddNewVessel = () => {
    if (
      validationGroupBerthName.current?.instance.validate().isValid &&
      validationGroupBerthCode.current?.instance.validate().isValid
    ) {
      const roleJsonEdit: IAddNewBerth = {
        berthName: berthName,
        berthCode: berthCode?.toString(),
        terminalCode: terminalCode,
      };
      api
        .post({ url: apiConfig.berthPost, data: roleJsonEdit }, setIsLoading)
        .then((response) => {
          if (response) {
            handleCancelClick();
            toast.success({
              title: t('toast.berthAddedSuccess'),
            });
            setIsFromAddBerth(true);
          }
        });
    }
  };

  return (
    <div>
      {isAddNewBerth && (
        <Modal
          modalConfig={modalConfigChangePWD}
          wrapperAttr={popupAttributesChangePWD}
        >
          <div className="m-l-confirmation-dialogbox-wrap">
            <div className="m-l-confirm-dialogbox-header m-l-cmn-modal-header">
              <div className="m-l-hdr-mdl-title">{t('labels.addNewBerth')}</div>
              <Button icon="close" onClick={handleCancelClick}></Button>
            </div>
            <div className="m-l-confirm-dialogbox-body">
              <ScrollView width="100%" height="100%">
                <div className="m-l-pwd-chng-wrap">
                  <form>
                    <div className="m-c-form-group mb-btm-space-24">
                      <label className="m-l-input-label">
                        {t('labels.berthName')}
                        <span className="m-l-input-required">*</span>
                      </label>
                      <ValidationGroup ref={validationGroupBerthName}>
                        <TextBox
                          className="m-c-input-control m-c-input-text"
                          value={berthName}
                          onValueChanged={(e) => {
                            setBerthName(e.value);
                          }}
                          validationMessageMode="always"
                        >
                          <Validator
                            validationRules={[
                              {
                                type: 'required',
                                message: t('errors.required'),
                              },
                            ]}
                          />
                        </TextBox>
                      </ValidationGroup>
                    </div>
                    <div className="m-c-form-group mb-btm-space-24">
                      <div className="m-l-label-icon-wrap">
                        <label className="m-l-input-label">
                          {t('labels.berthCode')}
                          <span className="m-l-input-required">*</span>
                        </label>
                      </div>
                      <ValidationGroup ref={validationGroupBerthCode}>
                        <TextBox
                          className="m-c-input-control m-c-input-text"
                          value={berthCode}
                          onValueChanged={(e) => {
                            setBerthcode(e.value);
                          }}
                          validationMessageMode="always"
                        >
                          <Validator
                            validationRules={[
                              {
                                type: 'required',
                                message: t('errors.required'),
                              },
                            ]}
                          />
                        </TextBox>
                      </ValidationGroup>
                    </div>
                  </form>
                </div>
              </ScrollView>
            </div>
            <div className="m-l-chp-mdl-footer">
              <Button
                className="app-c-btn app-c-btn--secondary"
                onClick={handleCancelClick}
              >
                {t('labels.cancel')}
              </Button>
              <Button
                className="app-c-btn app-c-btn--primary"
                onClick={onAddNewVessel}
              >
                {t('labels.save')}
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
